/* globals window document */

/**
 * Returns the current CSS breakpoint
 * @return {String}
 */
const getCssBreakpoint = () => window
  .getComputedStyle(document.querySelector('body'), ':before')
  .getPropertyValue('content')
  .replace(/"/g, '');

export default getCssBreakpoint;



// WEBPACK FOOTER //
// ./resources/assets/js/utils/getCssBreakpoint.js